import BarAndBox from './BarAndBox'

export default BarAndBox
